<subscription-page
  [subscription]="subscription()"
  [reportedStatus]="reportedStatus()"
  [isLoading]="isLoading()"
  [isNotFound]="isNotFound()"
  [isNotAuthorized]="isNotAuthorized()"
>
  @if (subscription(); as sub) {
    <firewall-subscription-view
      [subscription]="sub"
      [activities]="activities()"
      [activeTab]="activeTab()"
      [tabConfig]="tabConfig()"
      (tabChange)="changeActiveTab($event)"
    />
  }
</subscription-page>
